import React from 'react';
import styled from 'astroturf/react';
import _SpacerDiv from "VerticalSpacer-SpacerDiv.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/login_modal/components/VerticalSpacer.tsx?styleId=SpacerDiv";


export const SpacerDiv = /*#__PURE__*/styled('div', null, {
  displayName: "SpacerDiv",
  styles: _SpacerDiv
});

type Props = {
  height: number;
};
export const VerticalSpacer: React.FC<Props> = ({ height }) => {
  return <SpacerDiv style={{ height: height }} />;
};
